import { replyReadinessLevelSchema, replyReadinessReasonCodeSchema } from "../daemon/reply-readiness.js";
import * as z$1 from "zod/v4";
//#region src/schemas/start/shared.ts
const START_ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const START_TRIMMED_NON_EMPTY_STRING_SCHEMA = z$1.string().trim().min(1);
const START_BOUNDED_ID_SCHEMA = START_TRIMMED_NON_EMPTY_STRING_SCHEMA.max(256);
START_TRIMMED_NON_EMPTY_STRING_SCHEMA.max(256);
const START_BOUNDED_VERSION_SCHEMA = START_TRIMMED_NON_EMPTY_STRING_SCHEMA.max(128);
z$1.union([START_ISO_DATE_TIME_SCHEMA, z$1.null()]);
const startReplyReadinessSummarySchema = z$1.strictObject({
	level: replyReadinessLevelSchema,
	reasonCodes: z$1.array(replyReadinessReasonCodeSchema)
});
//#endregion
export { START_BOUNDED_ID_SCHEMA, START_BOUNDED_VERSION_SCHEMA, START_ISO_DATE_TIME_SCHEMA, START_TRIMMED_NON_EMPTY_STRING_SCHEMA, startReplyReadinessSummarySchema };

//# sourceMappingURL=shared.js.map